import { render, staticRenderFns } from "./CreateActivityGoodsDialog.vue?vue&type=template&id=0ecb7591&scoped=true&lang=pug&"
import script from "./CreateActivityGoodsDialog.vue?vue&type=script&lang=ts&"
export * from "./CreateActivityGoodsDialog.vue?vue&type=script&lang=ts&"
import style0 from "./CreateActivityGoodsDialog.vue?vue&type=style&index=0&id=0ecb7591&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ecb7591",
  null
  
)

export default component.exports